// extracted by mini-css-extract-plugin
export default {"wrapper":"Ky-z","viewport":"Ly-z","container":"My-z","slide":"Ny-z"};